<template>
     <!-- main section -->
  <section class="hero is-flex main">
    <div class="bg-img">
      <div class="img2 icon"><img src="../assets/images/book.png" alt=""></div>
      <div class="img3 icon"><img src="../assets/images/rocket.png" alt=""></div>
      <div class="img4 icon"><img src="../assets/images/cloud3.png" alt=""></div>
      <div class="img5 icon"><img src="../assets/images/award.png" alt=""></div>
      <div class="img6 icon"><img src="../assets/images/apple.png" alt=""></div>
    </div>
    
    <b-loading :is-full-page="false" :active.sync="isLoading" />
    
    <div class="title">{{ dashboardTitle }}</div>
    <div v-if="getUserType == 'A'" class="container flex">
      <Card size="is-4" v-for="(card, i) in showCards" :key="i" :img="card.img" :name="card.name"
        :styles="card.styles" :description="card.description" :router_name="card.router_name" />
    </div>
    <div class="container flex " v-if="getUserType == 'P'">
      <div v-if="fetchKids.length">
        <div v-for="(card, i) in userCards" :key="`kid-${i}`" @click="$router.push({ name: 'kiddetail_practice', params: card.router_params })" class="box">
            <div class="icon"><img src="../assets/images/user.svg" alt=""></div>
            <div class="box-title">{{ card.name }}</div>
        </div>
      </div>
      <!-- <div id="onboarding-kid" v-else>
        <img id="mascot-image" :src="require('@/assets/images/home-kid.png')" />
        <div>
          <div class="input-container">
            <input
              v-model="kid_name"
              type="text"
              placeholder="Enter the name of your kid"
            />
          </div>
          <div class="input-container">
            <input
              v-model="kid_dob"
              type="date"
              placeholder="Enter the date of birth for your kid"
            />
          </div>
          <a
              @click="addKid()"
              class="button is-size-5"
              style="background: #7409ff; color: #fff;"
            >
              <strong>Proceed</strong>
            </a>
        </div>
      </div>   -->
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/Card";

// var timetable = new Timetable();
export default {
  name: "Home",
  components: {
    Card,
  },
  data() {
    return {
      kid_name : "",
      kid_dob : "",
      isLoading : false,
      user_cards: [
      ],
    };
  },
  methods: {
    ...mapActions(["loadKids", "createKid"]),
    addKid(){
      this.isLoading = true
      this.createKid({
        token : this.getTeacherToken,
        kid : {
          name : this.kid_name,
          dob : this.kid_dob
        }
      }).then(() => {
        this.$buefy.toast.open({
              message: "Hurray! Lets get started now!",
              type: "is-success",
            });
        this.$confetti.start();
        setTimeout(() => {
          this.$confetti.stop();
        }, 3000);
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  computed: {
    ...mapGetters([
      "getUserType",
      "getTeacherToken",
      "fetchMenu",
      "fetchAdministratorMenu",
      "fetchColors",
      "fetchKids",
    ]),
    dashboardTitle(){
      if(this.isLoading) return ""

      const title = "Dashboard"
      
      return title
    },
    showCards() {
      if (this.getUserType == "T") return this.fetchMenu;
      else if (this.getUserType == "A") return this.fetchAdministratorMenu;
      
      //If nothing is true return nothing
      return [];
    },
    userCards() {
      const colors_length = this.fetchColors.length;
      let kid_cards = [];
      for (let kid_index in this.fetchKids) {
        let kid = this.fetchKids[kid_index];
        kid_cards.push({
          name: kid.name,
          title_size: "is-2",
          styles: {
            card_color: this.fetchColors[colors_length - 1 - kid_index],
          },
          router_params: {
            kid_id: kid._id,
          },
        });
      }
      return [...this.user_cards, ...kid_cards];
    },
  },
  created() {
    this.isLoading = true
    if(this.getUserType=="SA"){
      this.$router.push({
          name : 'school-home'
      })
    }
    this.loadKids({
      token: this.getTeacherToken,
    }).finally(() => {
      this.isLoading = false
    }) 
  },
};
</script>
<style scoped>
.input-container {
  border: 1px solid #c2c2c2;
  border-radius: 0.5rem;
  padding: 10px 10px;
  width: 100%;
  min-width : 300px;
  margin: 20px 0;
  position: relative;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 4%;
}
.input-container input {
  all: unset;
  flex: 1;
  width: 100%;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}

.main {
  align-items: center;
  margin: 0vw 0vw;
  position: relative;
  gap: 2.4vw;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
  .title{
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
}

@media screen and (max-width: 467px){
  .title{
    font-size: 5vw !important;
  }
}
/* background image */
.bg-img .icon {
  max-width: 7vw;
  height: auto;
}
.bg-img .img1 {
  bottom: 0;
  left: 0;
  right: 0;
}
.bg-img .img2 {
  top: 50%;
  right: 13.5%;
}
.bg-img .img3 {
  top: 66.33%;
  left: 21.7%;
}
.bg-img .img4 {
  top: 36.33%;
  right: 7.625%;
}
.bg-img .img5 {
  top: 54.44%;
  left: 7.4375%;
}
.bg-img .img6 {
  top: 51.67%;
  left: 18.6%;
}
.logo-container {
  margin-left: 60px;
}
/* main section */
.main {
  background: url(../assets/images/cloud2.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  padding: 6.76vw 4.4vw 18vw;
  margin: 0;
  min-height: 90vh;
}
.main .page-title {
  font-weight: 600;
  font-size: 36px;
  line-height: 45px;
}
.main .container .box {
  display: flex;
  align-items: center;
  gap: 2vw;
  width: 100%;
  max-width: 34.26vw;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0px 20px 40px rgb(0 0 0 / 13%);
  border-radius: 1.1vw;
  padding: 2vw;
  margin: 0;
  cursor:pointer;
}
.main .container .icon {
  width: 2vw;
  height: auto;
}
.main .container .box-title {
  font-weight: 600;
  font-size: 2vw;
  color: #202020;
  text-transform: capitalize;
}

.main .container .box:hover {
  border-color: #8919e7;
}
.main .container {
  width: 100%;
  gap: 3.73vw;
  justify-content: flex-start;
}

/* responsive page*/

/* tablet */
@media screen and (max-width: 1024px) {
  .main .container .box {
    box-shadow: 0px 15px 20px rgb(0 0 0 / 13%);
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .main .container .box {
    padding: 3.5vw;
  }
}

#onboarding-kid{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 50px;
}

#mascot-image{
  height: 300px;
  width: 300px;
}
</style>